import { Fragment, h } from 'preact';
import s from "./paginator.module.css";
import {usePaginator} from "./usePaginator";
import { useAppContext } from '../../contexts';

const Paginator = props => {
    // Destructured props
    const {
        data,
        handlePagination
    } = props;

    // Component logic data
    const componentProps = usePaginator({
        data,
        handlePagination
    });

    // Destructured component logic data
    const {
        currentPage,
        handleChange,
        handleManualChange
    } = componentProps;

    const {highContrast} = useAppContext();
    
    const maxPageNumbers = 5;

      // Gera os números das páginas
    const totalPages = Math.ceil(data.totalCount / data.pageSize);

    let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbers / 2));
    let endPage = Math.min(startPage + maxPageNumbers - 1, totalPages);

    // Ajusta o início se o final ultrapassar o número total de páginas
    startPage = Math.max(1, endPage - maxPageNumbers + 1);

    const pageNumbers = [];

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    return pageNumbers.length > 1 ? (
        <Fragment>
            <div className={"flex flex-row justify-between gap-x-2"}>
                <button
                    type={"button"}
                    className={`
                        ${s.paginatorButton} 
                        ${currentPage === 1 ? " hidden" : ""}
                        ${highContrast ? "highButton" : ""}
                    `}
                    onClick={() => handleManualChange("prev")}
                    data-testid="paginator-prev-button"
                >
                    Anterior
                </button>
                {pageNumbers.map((number) => {
                    return (
                        <button
                            key={number}
                            type={"button"}
                            className={`
                                ${s.paginatorButton} ${currentPage === number ? " active " : " "}
                                ${highContrast ? "highButton" : ""}
                            `}
                            onClick={() => handleChange(number)}
                            data-testid={`paginator-page-button-${number}`}
                        >
                            {number}
                        </button>
                    )
                })}
                <button
                    type={"button"}
                    className={`
                        ${s.paginatorButton} 
                        ${currentPage === data.totalPages ? " hidden" : ""}
                        ${highContrast ? "highButton" : ""}
                    `}
                    onClick={() => handleManualChange("next")}
                    data-testid="paginator-next-button"
                >
                    Próximo
                </button>
            </div>
        </Fragment>
    ) : null;
}

export default Paginator;
